export default __webpack_public_path__ + "static/media/notification-icon.bcc87604.svg";